module.exports = __webpack_public_path__ + "static/media/relationships.bd892969.png";